import { useAtomValue } from "jotai";
import type { NextPage } from "next";
import { useEffect } from "react";

import { useTopBannerAdSlot } from "scmp-app/components/advertisement/ad-slots/top-banner-ad-slot/hooks";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";
import { AppFooter } from "scmp-app/components/app-footer";
import { GamesLoading } from "scmp-app/components/games/loading";
import { OtherLoadingDuration } from "scmp-app/components/games/loading/consts";
import { useLoadingTimer } from "scmp-app/components/games/loading/hooks";
import { PageSeo } from "scmp-app/components/meta";
import { trackingAtom } from "scmp-app/components/tracking";
import { useGameIframe, useGameSeo } from "scmp-app/pages/games/hooks";

import { GamePageSchema } from "./schema";
import { IframeContainer, IframeWrapper } from "./styles";

const GamesPage: NextPage = () => {
  const { iframeId } = useGameIframe({ path: "games" });

  const isLoading = useLoadingTimer(OtherLoadingDuration);
  const adZone = "game/home";

  const seo = useGameSeo();

  useTopBannerAdSlot({
    desktop: {
      adUnit: "d_banner1",
      autoRefreshOptions: {
        intervalRefreshOptions: {
          isDisable: false,
        },
        scrollBackRefreshOptions: {
          isDisable: true,
        },
      },
      sizes: [
        [970, 250],
        [728, 90],
        [970, 90],
      ],
      targeting: {
        paid: TargetingPaidType.NotArticle,
      },
      zone: adZone,
    },
    mobile: {
      adUnit: "m_banner3",
      autoRefreshOptions: {
        intervalRefreshOptions: {
          isDisable: false,
        },
        scrollBackRefreshOptions: {
          isDisable: true,
        },
      },
      sizes: [
        [300, 100],
        [320, 100],
        [300, 50],
        [320, 50],
      ],
      targeting: {
        paid: TargetingPaidType.NotArticle,
      },
      zone: adZone,
    },
  });

  const { trackPageView } = useAtomValue(trackingAtom);
  useEffect(() => {
    trackPageView?.();
  }, [trackPageView]);

  return (
    <>
      <PageSeo {...seo} />
      <GamePageSchema />
      <IframeContainer $isLoading={isLoading}>
        <IframeWrapper id={iframeId} />
        <GamesLoading duration={OtherLoadingDuration} isLoading={isLoading} useGif={true} />
      </IframeContainer>
      {!isLoading && <AppFooter variant="games" />}
    </>
  );
};

const pageProps = {
  appBarConfiguration: {
    adSlotVariants: {
      large: {
        height: 250,
        padding: 20,
      },
      small: {
        height: 100,
        padding: 10,
      },
    },
    hasDesktopAd: true,
    hasMobileAd: true,
    variant: "scmp/slim",
  },
  contentConfiguration: {
    responsivePadding: {
      desktopUp: 12,
      tabletUp: 0,
    },
  },
  pageConfiguration: {
    responsivePadding: {
      tabletUp: 24,
    },
  },
};

GamesPage.getInitialProps = () => pageProps;

export default GamesPage;
